module.exports = __webpack_public_path__ + "img/cost.828bc99e.jpg";